import { useEffect } from 'react'

import { eventLogger } from 'services/eventLogger.service'

import { TSource } from '../constants'

type TParams = { isVisible: boolean }

export const useCookieConsentTracking = ({ isVisible }: TParams) => {
  useEffect(() => {
    if (!isVisible) return

    eventLogger.logCookiesConsentShown()
  }, [isVisible])

  const logSettingsTap = () => eventLogger.logCookiesConsentSettingsTap()

  const logAcceptAll = (source: TSource) =>
    eventLogger.logCookiesConsentAcceptAllTap(source)

  const logRejectAll = (source: TSource) =>
    eventLogger.logCookiesConsentRejectAllTap(source)

  const logToggleEnable = (option: string) =>
    eventLogger.logCookiesConsentToggleEnable(option)

  const logToggleDisable = (option: string) =>
    eventLogger.logCookiesConsentToggleDisable(option)

  return {
    logSettingsTap,
    logAcceptAll,
    logRejectAll,
    logToggleEnable,
    logToggleDisable,
  }
}
